<script setup lang="ts">
import type {
  ProductFilterTagWithCount,
  ProductSmartFilterDetail,
} from '~/types/api'

const selectedTagsIds = defineModel<number[]>({
  required: true,
})

const props = defineProps<{
  smartFilter?: ProductSmartFilterDetail | null
  selectedTags: ProductFilterTagWithCount[]
}>()

const router = useRouter()
const route = useRoute()
const localePath = useLocalePath()

function removeAllTags() {
  if (props.smartFilter) {
    router.push(localePath({ name: 'products' }))
  } else {
    selectedTagsIds.value = []
  }
}
</script>

<template>
  <div
    v-if="props.selectedTags.length > 0 || props.smartFilter"
    class="flex flex-grow flex-wrap items-center gap-4"
  >
    <ProductsFiltersChip
      v-if="props.smartFilter"
      :title="props.smartFilter.title"
      removable
      :clickable="false"
      :underline="false"
      @remove="
        router.push(localePath({ name: 'products', query: route.query }))
      "
    />
    <ProductsFiltersChip
      v-for="tag in props.selectedTags"
      :key="tag.nid"
      :title="tag.displayLabel || tag.title"
      removable
      :clickable="false"
      :underline="false"
      @remove="
        () => (selectedTagsIds = selectedTagsIds.filter((t) => t !== tag.nid))
      "
    />
    <ProductsFiltersChip
      class="!px-0"
      :title="$t('base.products.filters.removeAllFilters')"
      plain
      removable
      @click="removeAllTags()"
      @remove="removeAllTags()"
    />
  </div>
</template>
